import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { couponDetails, percentage_value_type } from "../../constant/constant";
import useAllCharges from "../../hooks/AllCharge";
import ParseFloat from "../../utils/ParseFloat";
import { useDispatch, useSelector } from "react-redux";
import useReduxData from "../../hooks/useReduxData";
import { SETTOTALCOUPONTOTAL } from "../../redux/features/CartData";
import useDiscountApply from "../../hooks/useDiscountApply";
import Promotions from "./Promotions";
const CouponCode = (props: any) => {
  const { t } = useTranslation();
  const {setIsDiscountApply}=useDiscountApply()
  const {
    cartData: { discountCouponTotal, isDiscountApply },
  } = useReduxData();



  // Calculate discounted price

  const handleDiscount = () => {
    setIsDiscountApply()
  };

  return (
    <>
      {/* <Promotions /> */}
      <div className="md:p-5 p-4 bg-white md:rounded-[10px] md:mb-5 md:border-none  border-b-2 border-[#E2E2E2]">
        {/* Header: Total and discount */}
        {/* <Promotions /> */}
        <div className="flex justify-between mb-4 items-baseline ">
          {/* mobile-map-hide */}
          <p className="text-xl font-splekta font-normal">
            {t("Checkout.discount_label")}
          </p>
          <div className="text-right">
            <p className="text-sm text-green-600 mb-0">
              {ParseFloat(discountCouponTotal)} off
            </p>
          </div>
        </div>

        {/* Coupon section */}
        <div
          key="coupon-code"
          className={`flex items-center justify-between border-t  pt-4 cursor-pointer ${
            isDiscountApply ? "" : ""
          }`}
        >
          {/* Left side: radio/check + label */}
          <div
            className="flex items-center gap-3 cursor-pointer"
            onClick={() => handleDiscount()}
          >
            <div
              className={`w-5 h-5 flex items-center justify-center border-2 rounded-sm transition-colors ${
                isDiscountApply
                  ? "bg-black border-black"
                  : "bg-white border-gray-400"
              }`}
            >
              {isDiscountApply && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4 text-white"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-7.364 7.364a1 1 0 01-1.414 0L3.293 9.707a1 1 0 011.414-1.414l3.222 3.222 6.657-6.657a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
            </div>
            <span className="text-gray-800 font-medium">
              {couponDetails.label}
            </span>
          </div>

          {/* Right side: Apply / Remove button */}
          {/* <button
          className={`text-sm px-3 py-1 rounded ${
            isDiscountApply
              ? "bg-red-500 text-white hover:bg-red-600"
              : "bg-black text-white hover:bg-gray-800"
          }`}
          onClick={() => handleDiscount()}
        >
          {isDiscountApply ? "Remove" : "Apply"}
        </button> */}
        </div>
      </div>
    </>
  );
};

export default CouponCode;
